/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_PricingInputs */

const en_directory_detail_pricing = /** @type {(inputs: Directory_Detail_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_directory_detail_pricing = /** @type {(inputs: Directory_Detail_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Directory_Detail_PricingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_pricing = /** @type {((inputs?: Directory_Detail_PricingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_PricingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_pricing(inputs)
	return zh_directory_detail_pricing(inputs)
});
export { directory_detail_pricing as "directory.detail.pricing" }